import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useTranslation } from 'react-i18next';
import {
    StyledColumnBox,
    StyledGreenButton,
    StyledMediumTypography,
    StyledModalButtons,
    StyledRowBox
} from '../theme/StyledElements';
import { ClientDetails } from './Dashboard/ClientDetails';
import { useEffect, useState } from 'react';
import { getGroupClients, getSpecificOrder } from '../services/cloudFirestore';
import { PartagePanier } from '../models/PartagePanier';
import { SharedClientDetails } from './Dashboard/SharedClientDetails';
import { Commandes } from '../models/Commandes';
import { useMountedRef } from '../hooks/useMountedRef';
import { BasketGroupData } from '../models/BasketGroupData';

const style = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '750px',
    bgcolor: 'background.paper',
    border: '2px solid #134C03'
};

interface ModalContainerProps {
    id: string | undefined;
    isModelOpen: boolean;
    setModelOpen: Function;
    title: JSX.Element;
    onButtonClick: Function;
}

export function ModalContainer({
    id,
    isModelOpen,
    setModelOpen,
    title,
    onButtonClick
}: ModalContainerProps): JSX.Element {
    const { t } = useTranslation();
    const mounted = useMountedRef();
    const [order, setOrder] = useState<Commandes>();
    const [partagePanier, setPartagePanier] = useState<BasketGroupData[]>([]);
    const [primaryData, setPrimaryData] = useState<PartagePanier>({
        idPanier: undefined,
        idClient: undefined
    });

    useEffect(() => {
        if (id && mounted.current) {
            getSpecificOrder(id).then((orderData) => {
                if (orderData && mounted.current) {
                    setOrder(orderData);
                    if (orderData.groupId && orderData.clientId) {
                        getGroupClients(
                            orderData.clientId,
                            orderData.groupId,
                            orderData.groupMemberOrderIds,
                            orderData.groupMemberOrderStatuses
                        ).then((obj) => {
                            setPartagePanier(obj);
                        });
                    }
                    if (orderData.baskets && orderData.clientId && mounted.current) {
                        setPrimaryData({
                            idPanier: orderData.baskets,
                            idClient: orderData.clientId
                        });
                    }
                }
            });
        }
    }, [id]);

    const body = (
        <Box sx={style}>
            {title}
            <StyledRowBox sx={{ margin: '40px', maxHeight: '500px', overflowY: 'scroll' }}>
                <StyledColumnBox sx={{ marginRight: '20px' }}>
                    <StyledMediumTypography variant="body1" color="#134C03">
                        {t('mainCommand')}
                    </StyledMediumTypography>
                    <ClientDetails primaryData={primaryData} order={order} />
                </StyledColumnBox>
                <StyledColumnBox>
                    <StyledMediumTypography variant="body1" color="#134C03">
                        {t('relatedCommands')}
                    </StyledMediumTypography>
                    <SharedClientDetails partagePanier={partagePanier} />
                </StyledColumnBox>
            </StyledRowBox>
            <StyledModalButtons>
                <StyledGreenButton
                    onClick={(): void => {
                        setPartagePanier([]);
                        onButtonClick();
                    }}>
                    <StyledMediumTypography variant="caption" color="#FFFFFF">
                        {t('toClose')}
                    </StyledMediumTypography>
                </StyledGreenButton>
            </StyledModalButtons>
        </Box>
    );

    return (
        <Modal
            open={isModelOpen}
            onClose={(): void => {
                setModelOpen(false);
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            {body}
        </Modal>
    );
}
